/* eslint-disable react/prop-types */
import { Box, Container, Stack, Typography } from "@mui/material";
import { usePhotosByGroup } from "../Contexts/UsePhotoManifest";
import FramedPhoto from "./FramedPhoto";
import Logo from "./Logo";
import React from "react";
import { BlackLogo } from "../consts";
// Seven slots scattered toward the edges, leaving a clear pocket in the
// middle for the text. Sizes/rotations vary so it reads as photos loosely
// scattered around a table, not a tidy ring. Add/remove entries here to
// change how many photos show — each maps by index to whatever
// usePhotosByGroup("hero") returns, so the photos themselves are managed
// entirely by tagging them in photo-metadata.json, not by editing this file.
const SCATTER_LAYOUT = [
    { top: "6%", left: "12%", width: "17%", rotate: 5 },
    { top: "5%", left: "70%", width: "16%", rotate: -6 },
    { top: "36%", left: "2%", width: "14%", rotate: -3 },
    { top: "40%", left: "83%", width: "13%", rotate: 3 },
    { top: "65%", left: "15%", width: "16%", rotate: -3 },
    { top: "67%", left: "65%", width: "16%", rotate: 5 },
    { top: "10%", left: "70%", width: "1%", rotate: 5 },
];
// Mobile masonry: the two columns get slightly different rotation patterns
// and the right column starts lower (via a top margin below), so the
// result reads as loosely staggered rather than a tidy aligned grid.
const LEFT_COLUMN_ROTATIONS = [-3, 4];
const RIGHT_COLUMN_ROTATIONS = [3, -4];
export default function HeroAndValues() {
    const heroPhotos = usePhotosByGroup("hero"); // tag photos with a "hero" group entry to control which show here, and in what order
    const featuredPhoto = heroPhotos[0];
    const remainingPhotos = heroPhotos.slice(1, 7); // up to 6 more, split across two columns below
    const leftColumnPhotos = remainingPhotos.filter((_, i) => i % 2 === 0);
    const rightColumnPhotos = remainingPhotos.filter((_, i) => i % 2 === 1);
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: {
                display: { xs: "none", sm: "block" },
                position: "relative",
                width: "100%",
                minHeight: { sm: 640, md: 760 },
                px: { sm: 4, md: 6 },
                py: { sm: 6 },
            } },
            SCATTER_LAYOUT.map((pos, i) => {
                const photo = heroPhotos[i];
                if (!photo)
                    return null;
                return (React.createElement(Box, { key: photo?.src, sx: {
                        position: "absolute",
                        top: pos.top,
                        left: pos.left,
                        width: pos.width,
                        transform: `rotate(${pos.rotate}deg)`,
                        zIndex: 1,
                    } },
                    React.createElement(FramedPhoto, { src: photo.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 })));
            }),
            React.createElement(Box, { sx: {
                    position: "absolute",
                    top: "30%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { sm: "44%", md: "38%" },
                    textAlign: "center",
                    zIndex: 2,
                } },
                React.createElement(Stack, { spacing: 1.5, alignItems: "center" },
                    React.createElement(Logo, { fileName: BlackLogo }),
                    React.createElement(Typography, { sx: {
                            fontFamily: "'Alex Brush', cursive",
                            // fontSize: "2rem",
                            fontSize: { sm: 32, md: 70 },
                            lineHeight: 1.15,
                        } }, "Capturing Moments That Last A Lifetime"),
                    React.createElement(Typography, { sx: {
                            fontFamily: "'Playfair Display', serif",
                        } }, "Wheaton family photographer")))),
        React.createElement(Container, { maxWidth: "xs", sx: { display: { xs: "block", sm: "none" }, py: 2 } },
            React.createElement(Stack, { spacing: 1.5, alignItems: "center", sx: { textAlign: "center", mb: 2 } },
                React.createElement(Logo, { fileName: BlackLogo, sx: {
                        width: 220, // a bit larger than the header's xs:130 — this is a hero moment, not a nav bar
                        height: "auto",
                    } }),
                React.createElement(Typography, { sx: {
                        fontFamily: "'Alex Brush', cursive",
                        fontSize: { xs: 40, sm: 70, md: 70 },
                        lineHeight: 1.15,
                    } }, "Capturing Moments That Last A Lifetime"),
                React.createElement(Typography, { sx: {
                        fontSize: 10,
                        letterSpacing: 1,
                        fontFamily: "'Playfair Display', serif",
                    } }, "Wheaton family photographer")),
            featuredPhoto && (React.createElement(Box, { sx: {
                    width: "82%",
                    mx: "auto",
                    mb: 3.5,
                    transform: "rotate(-2deg)",
                } },
                React.createElement(FramedPhoto, { src: featuredPhoto.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 }))),
            React.createElement(Box, { sx: { display: "flex", gap: 2, alignItems: "flex-start" } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        width: "50%",
                    } }, leftColumnPhotos.map((photo, i) => (React.createElement(Box, { key: photo.src, sx: {
                        transform: `rotate(${LEFT_COLUMN_ROTATIONS[i % LEFT_COLUMN_ROTATIONS.length]}deg)`,
                    } },
                    React.createElement(FramedPhoto, { src: photo.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 }))))),
                React.createElement(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        width: "50%",
                        mt: 5, // the actual "stagger" — offsets this column down from the left
                    } }, rightColumnPhotos.map((photo, i) => (React.createElement(Box, { key: photo.src, sx: {
                        transform: `rotate(${RIGHT_COLUMN_ROTATIONS[i % RIGHT_COLUMN_ROTATIONS.length]}deg)`,
                    } },
                    React.createElement(FramedPhoto, { src: photo.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 })))))))));
}
